import React, { FC, useEffect } from 'react'
import { ExportSortieForm, SortieCommentaireForm } from '../services/sortie.types'
import { Grid, MenuItem, withStyles } from '@material-ui/core'
import { FormattedMessage } from 'react-intl'
import { getStyles } from 'isotope-client'
import { compose } from 'redux'
import { ConfigProps } from 'redux-form/lib/reduxForm'
import { connect } from 'react-redux'
import { Field, FormErrors, formValueSelector, InjectedFormProps, reduxForm } from 'redux-form'
import { EXPORT_FORM_FIELDS, EXPORT_SORTIE_FORM, EXPORT_TYPE_BY_ORIGIN } from '../services/sortie.consts'
import { SORTIE_EXPORT_ORIGIN, SORTIE_EXPORT_TYPE } from '../services/sortie.enums'
import Select from '../../../../components/form/Select'
import { Client } from '../../../common/client/client.types'
import Input from '../../../../components/form/Input'
import { getClients } from '../../../common/client/client.api'
import { getPreferences } from '../../../common/user/services/userSelectors'

const styles = () => getStyles({
	container: {
		margin: '12px 24px',
		maxWidth: 800
	},
	form: {
		margin: '0px 36px 0px 26px',
		width: '100%'
	},
	description: {
		display: 'block' as 'block',
		whiteSpace: 'pre-line' as 'pre-line',
		textAlign: 'justify' as 'justify',
		margin: '0px 12px 12px 12px'
	}
})

type ExportSortieDialogProps = {
	idFerme: string
	origin: SORTIE_EXPORT_ORIGIN
	selectedExportType: SORTIE_EXPORT_TYPE
	classes: ClassNameMap
}

const validate = (values: SortieCommentaireForm): FormErrors<SortieCommentaireForm> => {
	const errors: FormErrors<SortieCommentaireForm> = {}

	const exportType = values[EXPORT_FORM_FIELDS.EXPORT_TYPE as keyof SortieCommentaireForm]

	// Si sélection hors tableau, client obligatoire
	if (exportType !== SORTIE_EXPORT_TYPE.TABLEAU_SORTIE && !values[EXPORT_FORM_FIELDS.CLIENT as keyof SortieCommentaireForm]
	) {
		errors[EXPORT_FORM_FIELDS.CLIENT as keyof SortieCommentaireForm] = <FormattedMessage id="global.errors.mandatory" />
	}

	// Si sélection fichier récolte hebdo, num semaine entre 1 et 53
	const numSemaine = values[EXPORT_FORM_FIELDS.SEMAINE as keyof SortieCommentaireForm] ?? 0
	if (exportType === SORTIE_EXPORT_TYPE.RECOLTE_THEORIQUE_SEMAINE && (numSemaine < 1 || numSemaine > 53)
	) {
		errors[EXPORT_FORM_FIELDS.SEMAINE as keyof SortieCommentaireForm] = <FormattedMessage id="sorties.export.popin.errorSemaine" />
	}

	return errors
}

/**
 * Dialog d'export des sortie
 */
const ExportSortieDialog: FC<ExportSortieDialogProps & InjectedFormProps<SortieCommentaireForm>> = (
	{
		idFerme,
		origin,
		selectedExportType,
		handleSubmit,
		classes
	}
) => {
	const [clients, setClients] = React.useState<Client[]>([])

	const exportOptions = EXPORT_TYPE_BY_ORIGIN[origin]

	useEffect(() => {
		getClients()
			.then(setClients)
	}, [idFerme])

	return <Grid container className={classes.container}>
		<form onSubmit={handleSubmit} className={classes.form}>
			<Grid item xs={12} className={classes.description}>
				<FormattedMessage id={`sorties.export.description.${origin}`} />
			</Grid>
			<Field
				name={EXPORT_FORM_FIELDS.EXPORT_TYPE}
				component={Select}
				label={<FormattedMessage id="sorties.export.popin.exportType" />}
				disabled={exportOptions.length === 1}
				reverseBackground
			>
				{exportOptions.map(exportType =>
					<MenuItem key={`export-${exportType}`} value={exportType}>
						<FormattedMessage id={`enums.exportSortie.${exportType}`} />
					</MenuItem>
				)}
			</Field>
			{selectedExportType !== SORTIE_EXPORT_TYPE.TABLEAU_SORTIE &&
				<Field
					name={EXPORT_FORM_FIELDS.CLIENT}
					component={Select}
					label={<FormattedMessage id="sorties.export.popin.client" />}
					reverseBackground
				>
					{clients
						.filter(client => !client.interne)
						.map(client =>
							<MenuItem key={client.id} value={client.id}>
								{client.raisonSociale}
							</MenuItem>
						)}
				</Field>
			}
			{selectedExportType === SORTIE_EXPORT_TYPE.RECOLTE_THEORIQUE_SEMAINE &&
				<Field
					name={EXPORT_FORM_FIELDS.SEMAINE}
					component={Input}
					label={<FormattedMessage id="sorties.export.popin.semaine" />}
					type="number"
					style={{ maxWidth: 200 }}
					reverseBackground
				/>
			}
		</form>
	</Grid>
}

const mapStateToProps = (state: any, { origin }: { origin: SORTIE_EXPORT_ORIGIN }) => {
	return ({
		initialValues: {
			[EXPORT_FORM_FIELDS.EXPORT_TYPE]: EXPORT_TYPE_BY_ORIGIN[origin][0]
		},
		idFerme: (getPreferences(state).FERME_ID || '0'),
		selectedExportType: formValueSelector(EXPORT_SORTIE_FORM)(state, EXPORT_FORM_FIELDS.EXPORT_TYPE)
	})
}

export default compose<FC<ConfigProps<ExportSortieForm> & { origin: SORTIE_EXPORT_ORIGIN }>>(
	connect(mapStateToProps),
	reduxForm({
		form: EXPORT_SORTIE_FORM,
		enableReinitialize: true,
		validate
	}),
	withStyles(styles)
)(ExportSortieDialog)